import { RootState } from '../../app/store'
import { createSlice } from '@reduxjs/toolkit'
import { IpdSearchOptions } from './Constants'

type UnidentifiedPatient = {
  firstName: string
  lastName: string
  age: number
  gender: string
  patientId: string
}

export type ProrithmSlice = {
  addDeviceCount: number
  patientInfo: IpdSearchOptions | null
  unidentifiedPatientDetails: UnidentifiedPatient | null
  mapTo: string
}

const initialState: ProrithmSlice = {
  addDeviceCount: 0,
  patientInfo: null,
  unidentifiedPatientDetails: null,
  mapTo: '',
}

const prorithmSlice = createSlice({
  name: 'prorithmDevices',
  initialState,
  reducers: {
    setAddDeviceCount: (state) => {
      state.addDeviceCount += 1
    },
    setPatientInfo: (state, action) => {
      state.patientInfo = action.payload
    },
    setUnidentifiedPatientDetails: (state, action) => {
      state.unidentifiedPatientDetails = action.payload
    },
    setMapTo: (state, action) => {
      state.mapTo = action.payload
    },
  },
})

export const {
  setAddDeviceCount,
  setPatientInfo,
  setUnidentifiedPatientDetails,
  setMapTo,
} = prorithmSlice.actions

export const selectAddDeviceCount = (state: RootState) =>
  state.prorithmDevices.addDeviceCount

export const selectPatientInfo = (state: RootState) =>
  state.prorithmDevices.patientInfo

export const selectUnidentifiedPatientDetails = (state: RootState) =>
  state.prorithmDevices.unidentifiedPatientDetails

export const selectMapTo = (state: RootState) => state.prorithmDevices.mapTo

export default prorithmSlice.reducer
